import type Dropdown from '@Component/Dropdown/Dropdown';

export default class InputDropdownUI {
    public input: HTMLInputElement;
    public dropdown: Dropdown;

    constructor(public el: HTMLElement) {
        this.input = this.el.queryRole<HTMLInputElement>('input');
        this.dropdown = this.el.queryRole<Dropdown>('dropdown');
    }
}
